var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CockpitDialog',{staticClass:"cameraPicture",attrs:{"title":"监控画面"},on:{"close":_vm.close}},[_c('YSPlayer',{staticClass:"w-full h-full",attrs:{"code":_vm.deviceCode,"showControlPanel":true,"pIid":_vm.plid}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }